import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useVesselOwnerForm = () => {
  const [formDatas, setFormDatas] = useState({
    companyName: "",
    registrationNumber: "",
    phoneNumber: "",
    phoneCountryCode: "", 
    yearsInOperation: "",
    website: "",
    linkedIn: "",
    serviceCategory: [],
    keywords: [],
    address: "",
    state: "",
    city: "",
    country: ""
  });

  const navigate = useNavigate();

  useEffect(() => {
    const storedFormData = localStorage.getItem("vesselOwnerFormData");
    if (storedFormData) {
      try {
        const parsedData = JSON.parse(storedFormData);
        setFormDatas(prev => ({
          ...prev,
          ...parsedData,
          phoneCountryCode: parsedData.phoneCountryCode || "",
          serviceCategory: Array.isArray(parsedData.serviceCategory) ? parsedData.serviceCategory : [],
          keywords: Array.isArray(parsedData.keywords) ? parsedData.keywords : [],
          companyName: parsedData.companyName || "",
          registrationNumber: parsedData.registrationNumber || "",
          phoneNumber: parsedData.phoneNumber || "",
          yearsInOperation: parsedData.yearsInOperation || "",
          website: parsedData.website || "",
          linkedIn: parsedData.linkedIn || "",
          address: parsedData.address || "",
          state: parsedData.state || "",
          city: parsedData.city || "",
          country: parsedData.country || ""
        }));
      } catch (error) {
        console.error("Error parsing stored form data:", error);
      }
    }
  }, []); // ✅ Only run once on mount
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDatas(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSelectionChange = (name, value) => {
    if (!value) return;
    setFormDatas(prev => ({
      ...prev,
      [name]: prev[name].includes(value) ? prev[name] : [...prev[name], value]
    }));
  };

  const removeSelection = (name, value) => {
    setFormDatas(prev => ({
      ...prev,
      [name]: prev[name].filter(item => item !== value)
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formDatas.companyName) {
      alert("Company name is required");
      return;
    }
    
    if (!formDatas.registrationNumber) {
      alert("Registration number is required");
      return;
    }
    
    if (!formDatas.phoneNumber) {
      alert("Phone number is required");
      return;
    }
    
    if (!formDatas.yearsInOperation) {
      alert("Years in operation is required");
      return;
    }
    
    if (!formDatas.website) {
      alert("Website is required");
      return;
    }
    
    if (!formDatas.linkedIn) {
      alert("LinkedIn is required");
      return;
    }
    
    if (formDatas.serviceCategory.length < 2) {
      alert("Please select at least 2 service categories");
      return;
    }
    
    if (formDatas.keywords.length < 2) {
      alert("Please select at least 2 keywords");
      return;
    }

    localStorage.setItem("vesselOwnerFormData", JSON.stringify(formDatas));
    // console.log("Form submitted:", formDatas);
    navigate("/createprofile_step_2");
  };

  return {
    formDatas,
    handleInputChange,
    handleFormSubmit,
    handleSelectionChange,
    removeSelection
  };
};

export default useVesselOwnerForm;